module.exports = __webpack_public_path__ + "img/Female-inactive.e0adaa91.svg";